import { render, staticRenderFns } from "./TireReplacementComponent.vue?vue&type=template&id=3bf384d6&"
import script from "./TireReplacementComponent.vue?vue&type=script&lang=js&"
export * from "./TireReplacementComponent.vue?vue&type=script&lang=js&"
import style0 from "./TireReplacementComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports